<div class="toc-layout-main"> 
    <ul class="dfwp-list">
       <li *ngFor="let circular of circulars; let i = index;" class="level-section level-item-pos level-item level-bullet">
         <span  class="notificationAlert" *ngIf="circular.NotificationCount > 0">
            {{circular.NotificationCount}}
         </span>
          <div class="level-header">
            <span class="headertitle headermarker"> 
              <a (click)="goToCircularTaks(circular.Id)">
                 {{circular.CircularNo}} - {{circular.Symbol}}
              </a>
            </span>
          </div>
       </li>
    </ul>
  </div>